/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestFilterCountsStringValues
 */
export interface RequestFilterCountsStringValues {
    /**
     * 
     * @type {number}
     * @memberof RequestFilterCountsStringValues
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestFilterCountsStringValues
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RequestFilterCountsStringValues
     */
    values: Array<string>;
}

export function RequestFilterCountsStringValuesFromJSON(json: any): RequestFilterCountsStringValues {
    return RequestFilterCountsStringValuesFromJSONTyped(json, false);
}

export function RequestFilterCountsStringValuesFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestFilterCountsStringValues {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'name': json['name'],
        'values': json['values'],
    };
}

export function RequestFilterCountsStringValuesToJSON(value?: RequestFilterCountsStringValues | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'name': value.name,
        'values': value.values,
    };
}


